import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import {Fade, Menu, MenuItem} from "@mui/material";
//import {useNavigate} from "react-router";
import SendWol from './utils/SendWol';

export default function ButtonAppBar() {

    //const navigate = useNavigate();
    const clickLogoutHandler = async () => {
        await fetch('/logout', {
            method: 'POST',

        });
        //navigate("/");
        window.location.reload();
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuWol = () => {
        SendWol().then(() => setAnchorEl(null));
    };

    const handleMenuLogout = () => {
        clickLogoutHandler().then(() => setAnchorEl(null));
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton
                        id="fade-button"
                        aria-controls={open ? 'fade-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open}
                        onClick={handleClick}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="fade-menu"
                        slotProps={{
                            list: {
                                'aria-labelledby': 'fade-button',
                            },
                        }}
                        slots={{ transition: Fade }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleMenuWol}>Send WOL</MenuItem>
                        <MenuItem onClick={handleMenuLogout}>Logout</MenuItem>
                    </Menu>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Remote Status
                    </Typography>
                    <Button color="inherit" onClick={clickLogoutHandler}>Logout</Button>
                </Toolbar>
            </AppBar>
        </Box>
    );
}